import { formatDecimal } from "./numberFormat";
import { parsePriceValue } from "./pricing";

export const PRICE_SYMBOL = "€";
export const DEFAULT_PRICE_SEPARATOR = " · ";

const formatCurrencyValue = (value) => {
  const parsed = parsePriceValue(value);
  if (parsed === null) return null;
  if (parsed <= 0) return "Free";
  const decimals = Number.isInteger(parsed) ? 0 : 2;
  return `${PRICE_SYMBOL}${formatDecimal(parsed, decimals)}`;
};

const getPriceRow = (card, rowsByKey, rowsById) =>
  (card.equipmentTypeId && rowsById?.[card.equipmentTypeId]) ||
  (card.pricingKey && rowsByKey?.[card.pricingKey]) ||
  null;

const formatPriceParts = (card, rowsByKey, rowsById) => {
  const row = getPriceRow(card, rowsByKey, rowsById);
  if (!row) return [];
  const periods = Array.isArray(card.pricePeriods) ? card.pricePeriods : [];
  return periods
    .map((period) => {
      const formatted = formatCurrencyValue(row[period.field]);
      if (!formatted) return null;
      const suffix = period.suffix || "";
      return formatted === "Free" ? formatted : `${formatted}${suffix}`;
    })
    .filter(Boolean)
    .slice(0, 2);
};

export const getPriceLabel = (card, rowsByKey, rowsById) => {
  const parts = formatPriceParts(card, rowsByKey, rowsById);
  if (parts.length) {
    const separator = card.priceSeparator ?? DEFAULT_PRICE_SEPARATOR;
    return parts.join(separator);
  }
  return card.priceLabel || "Free";
};
